var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrechStanPiteynaVodaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34 34",
    style: {
      enableBackground: "new 0 0 34 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.67,26.49c1.07,0,1.94-0.87,1.94-1.94c0-1.07-1.94-3.58-1.94-3.58s-1.94,2.51-1.94,3.58 C20.72,25.62,21.59,26.49,22.67,26.49z M30.17,21.81c0,0-4.01,7.67-10.65,8.2c-6.64,0.53-10.65-3.07-12.4-5.27 c-1.75-2.21-5.6-11.39,2.36-18.1C17.6-0.2,25.97,6.39,25.97,6.39l-1.69,1.33l6.65,2.05l-0.47-6.94l-1.41,1.11c0,0-1-1.4-5.89-3.11 c-4.89-1.71-11.1-0.78-16,2.6C2.29,6.81-3.38,17.82,4.02,27.18c7.41,9.36,18.68,7.62,23.97,3.43c5.29-4.19,5.55-7.14,5.55-7.14 L30.17,21.81z M7.64,13.17v3.25c0,0,5.34,0,9.15,0c3.96,0,4.43,0.38,4.43,1.77c0,0.98,0,2.07,0,2.07h3.25c0,0,0-1.87,0-2.95 c0-1.08-0.72-4.13-5.9-4.13c-2.4,0-4.43,0-4.43,0v-2.95h1.77V8.75h-5.31v1.48h2.07v2.95H7.64z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrechStanPiteynaVodaIcon);
export default __webpack_public_path__ + "static/media/prech_stan_piteyna_voda_icon.d7779efd.svg";
export { ForwardRef as ReactComponent };